import { useContext, useMemo } from 'react';
import { createFabricApi } from '@immediate_media/fabric-api-clients';
import { SiteContext } from '@immediate_media/pocket-config';

/**
 * A hook to get a configured fabric API client.
 *
 * The API client is configured with the relevant authentication functions,
 * see the fabric-api-clients package for details.
 *
 * https://github.immediate.co.uk/WCP-Packages/fabric-api-clients
 *
 * @example
 * const fabricApi = useFabricApi();
 *
 * fabricApi.collections.savedItems.get(42) // => Saved item 42
 */
const useFabricApi = (opts = {}) => {
  const {
    env,
    siteKey,
    apiBaseURLs
  } = useContext(SiteContext);
  const {
    useProxyApi
  } = opts;
  const fabricApi = useMemo(() => createFabricApi({
    env,
    siteKey,
    baseURLs: apiBaseURLs,
    useProxyApi
  }), [env, siteKey, apiBaseURLs, useProxyApi]);
  return fabricApi;
};
export default useFabricApi;